import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { LevelBuilder } from '../../models/builder/level.builder';

@Injectable()
export class LevelApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${ environment.companyAdmin.apiUrl }levels`;
  }

  getLevels() {
    return this.httpClient.get(`${ this.apiUrl }`)
      .pipe(map(LevelBuilder.fromList));
  }
}
